const { parseCookies } = require('./cookies'); // Adjust the import based on your project structure

const FB_VERSION = '1';

function generateFbp() {
	const timestamp = Date.now();
	const randomNumber = Math.floor(Math.random() * 1e10); // 10-digit random
	return `fb.${FB_VERSION}.${timestamp}.${randomNumber}`;
}

function generateFbc(fbclid) {
	if (!fbclid) return null;
	const timestamp = Date.now();
	return `fb.${FB_VERSION}.${timestamp}.${fbclid}`;
}

function getFbTrackingParams(cookieHeader) {
	const cookies = parseCookies(cookieHeader);
	let fbp = cookies['_fbp'];
	let fbc = cookies['_fbc'];

	if (!fbp) {
		fbp = generateFbp();
	}

	if (!fbc) {
		const fbclid = cookies['fbclid'];
		if (fbclid) {
			fbc = generateFbc(fbclid);
		} else {
			fbc = null;
		}
	}

	return { fbp, fbc };
}

module.exports = {
	generateFbp,
	generateFbc,
	getFbTrackingParams
};